import React from "react";
import MycircleRed from "./MycircleRed";
import Orderrow from "./Orderrow";
const Myrow = ({bgcolor,numresult,totalamount,selected,period, amount}) => {
  return (
    <>                                                                
   
      <tr className="table-everyone-order-row">
        <td className="text-align-tb">{period}</td>
        <td className="text-align-tb">
          <MycircleRed selected={selected} />
        </td>
        <td className="text-align-tb">₹{amount? amount:"0"}</td>
        <td className="text-align-tb">
         
        
        
          <Orderrow numresult={numresult} bgcolor={bgcolor}/>
        </td>
        <td className="text-align-tb">₹{totalamount}</td>
      </tr>
    </>
  );
};

export default Myrow;
